import { CategoryInterface } from 'components/Article/types';
import { colors } from 'components/styles/variables';
import { trackCtaClick } from 'lib/Tracking';

export function CtaButton({
  ctaText,
  ctaURL,
  category,
  pageName,
}: {
  ctaText: string;
  ctaURL: string;
  category: CategoryInterface;
  pageName: string;
}): JSX.Element | null {
  if (!pageName && !category) {
    return null;
  }

  if (ctaText && ctaURL) {
    const targetPage = new URL(ctaURL).pathname;
    return (
      <a
        href={ctaURL}
        className="cta-button"
        onClick={(): void => trackCtaClick(category ? category.name : '', pageName, targetPage)}
      >
        {ctaText}
        <style jsx>
          {`
            .cta-button {
              font-size: 16px;
              font-weight: 600;
              margin-top: 20px;
              color: white;
              background-color: ${colors.ALR1};
              border-radius: 6px;
              padding: 14px 36px;
            }

            .cta-button:hover {
              color: white;
              box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);
            }

            .cta-button:active {
              box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
            }
          `}
        </style>
      </a>
    );
  }
  return <></>;
}
